<app-header></app-header>
<main class="main-content">
    <!------main-content------>
    <!-----------page_title--------------->

    <!-----------footer--------------->
    <section class="contact_page pdb_70 pdt_100">
       <div class="container">
          <div class="row">
             <!---------row----------->

            <div  iv class="col-lg-6">
                <img src="assets/image/payment.png" class="img-fluid">
            </div>

             <div class="col-lg-6 col-md-12 mx-auto">

                
                <!---------col----------->
                <div class="contact_us_form">
                    <h2 class="update-recod-heading text-left mt-5">Make Payment</h2>
                   <div class="form_box type_one">
                      <form   autocomplete="off">
                         <div class="messages"></div>
                         <div class="controls">
                            <div class="row">
                               <div class="col-lg-12">
                                  <div class="form-group">
                                     <input type="text" class="percent_100 login_input_padding" name="name" placeholder="Enter appointment ID" />
                                  
                                     <!-- <div class="help-block with-errors"></div> -->
                                  </div>
                               </div>
                               
                           
                               <div class="col-lg-12">
                                  <div class="form-group text-center mt-4">
                                     <button type="button" data-toggle="modal" data-target="#exampleModalCenter" class="theme_btn tp_two logo-button-website">Fetch Record</button>
                                  </div>
                               </div>
                            </div>
                         </div>
                      </form>
                   </div>
                </div>
                <!---------col-end---------->
             </div>

          
             <!----------row-end---------->
          </div>
       </div>
    </section>
<app-footer></app-footer>
    
</main>
<app-scrolltotop></app-scrolltotop>
<app-whatsupchat></app-whatsupchat>


  
  <!-- Modal -->
  <div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header-custom">
          <h5 class="modal-title" id="exampleModalLongTitle">Confirm Appointment Details</h5>
          <button type="button" data-dismiss="modal" aria-label="Close">
            <i class="fas fa-times-circle"></i>
          </button>
        </div>
        <div class="modal-body">
          
           
                <!-- popup form start -->

                <form>

                    <div class="row">

                        <div class="col-lg-12 pl-5 pr-5 mb-3">
                            <div class="text-center text-center result-24-message"> 
                                <i class="fas fa-info-circle"></i> &nbsp; Results take 24 hours from receipt of your samples 
                            </div>
                        </div>
                       </div>

                    <div class="form-row">

                      

                      <div class="col-md-6 heading-text-popup">
                        Full Name:
                        
                      </div>
                      <div class="col-md-6 text-popup">
                        Amaka John Jones
                        
                      </div>
                    </div>

                    <div class="form-row">
                        <div class="col-md-6 heading-text-popup">
                          Passport No.:
                          
                        </div>
                        <div class="col-md-6 text-popup">
                          A343499349
                          
                        </div>
                      </div>


                      <div class="form-row">
                        <div class="col-md-6 heading-text-popup">
                          Date of Travel:
                          
                        </div>
                        <div class="col-md-6 text-popup">
                          1st July 2021
                          
                        </div>
                      </div>




                      <div class="form-row">
                        <div class="col-md-6 heading-text-popup">
                            Preferred Test Location:
                        </div>
                        <div class="col-md-6 text-popup">
                            Lalabo
                        </div>
                       
                      </div>

                      <div class="form-row">
                        <div class="col-md-6 heading-text-popup">
                            Prefferred Test Center:
                        </div>
                        <div class="col-md-6 text-popup">
                            Low East Side Medical Center
                        </div>
                       
                      </div>


                      <div class="form-row">
                        <div class="col-md-6 heading-text-popup">
                            Appointment:
                        </div>
                        <div class="col-md-6 text-popup">
                            Tue 29 June, 11:00am - 11:30am
                        </div>
                       
                      </div>

 
                   
                  </form>

                <!-- popup form end-->



        </div>
        <div class=" text-center pb-5">
           <button type="button" class="theme_btn tp_two logo-button-website  ">Confirm Payment</button>
        </div>
      </div>
    </div>
  </div>

